import { createTheme } from '@mui/material/styles';



const theme = createTheme(
    {
        palette:{   
            primary:{
                main:'#44D482',
            },
            secondary:{
                main:'#424348'
            },
            // background: '#3E3F43',
            background:{
                default: '#3E3F43',
                paper: '#44D482'
            },  
        },
        typography: {
            fontFamily: [
                'ubuntu',
                'Roboto',
                '"Helvetica Neue"',
            ].join(",")
        }
    }
);







export default theme;

